/**
 * Clés de cache du domaine `extensionCommand` — les commandes que le serveur
 * confie à l'extension (rafraîchir les posts, les analytics d'un post…) et dont
 * on relit le statut une fois terminées.
 *
 * Voir `src/hooks/profile/keys.ts` pour le pourquoi de la fabrique.
 */
export const extensionCommandKeys = {
  all: ['extensionCommand'] as const,

  /** `GET /extension/status/:id` : la commande et son résultat. */
  status: (commandId: string) => [...extensionCommandKeys.all, 'status', commandId] as const,

  mutations: () => [...extensionCommandKeys.all, 'mutation'] as const,
} as const;
